import { defineMessages } from 'react-intl';

export const messages: {
	emptyStatePlaceholderTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStatePlaceholderTitle: {
		id: 'company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder',
		defaultMessage: 'Give your card a title',
		description: 'Placeholder title that is displayed in Smart Card when no title is provided',
	},
});
